import React, { useState } from "react";
import qs from "query-string";
import { appName } from "../../../app.json";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import { useMutation, useQuery } from "react-apollo";
import "../../Patient/Patient.css";
import { ParentSite as __q } from "../../../queries/parent-site.query";
import Loading from "../../../partials/loading";
import auth from "../../../providers/Auth.Provider";
import SiteList from "./sitelist";
import CreateSite from "./create";
import SiteUpdate from "./update";
import ViewSite from "./view";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../util/app";
import { sendNotification } from "../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../event/model";
import { EventEmitter } from "../../../event/EventEmitter";

const Site = ({ location, match }) => {
    const [showSiteList, setShowSiteList] = useState(true);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showView, setShowView] = useState(false);
    const [site_item, setSite] = useState(null);

    // update patient id from query string
    const { ref } = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    const { site } = auth.authProvider.GetAuthenticatedStaff();
    const title = "Parent Site Details";

    const { loading: rloading, data: rdata, refetch } = useQuery(__q.QUERY.GETSITEPARENT, {
        variables: { id: ref, site: site && site.id },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    const [NewSite, { loading }] = useMutation(__q.MUTATION.CREATENEWSITE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.NewSite;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.SITE);
        },
    });

    const [UpdateSite, { loading: uLoading }] = useMutation(__q.MUTATION.UPDATESITE, {
        onCompleted: (d) => {
            const { message } = d.UpdateSite;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.SITE);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    if (!ref) return <Redirect to="/home/app-management/parent-site" />;

    EventEmitter.subscribe(EVENT_TARGET.SITE, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>Parent Site Information</header>
                            <div className="tools">
                                <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                            </div>
                        </div>

                        <div className="card-body">
                            {rloading && <Loading loading={rloading} />}

                            {rdata && (
                                <div className="height-9">
                                    <ul className="list-group list-group-unbordered">
                                        <li className="list-group-item">
                                            <b className="col-lg-4">Name:</b>
                                            <div className="col-lg-7 pull-right">{rdata.GetSiteParent.doc.name}</div>
                                        </li>
                                        <li className="list-group-item">
                                            <b className="col-lg-4">E-mail:</b>
                                            <div className="col-lg-7 pull-right">{rdata.GetSiteParent.doc.email}</div>
                                        </li>
                                        <li className="list-group-item">
                                            <b className="col-lg-4">Telephone: </b>
                                            <div className="col-lg-7 pull-right">{rdata.GetSiteParent.doc.tel_number}</div>
                                        </li>
                                    </ul>
                                    <div className="row list-separated profile-stat"></div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {showSiteList && (
                    <>
                        <div className="col-lg-8 col-md-12 col-sm-12 col-12 fade-in">
                            <div className="card">
                                <div className="card-head">
                                    <header>
                                        {rdata && rdata.GetSiteParent.doc.sites && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setShowSiteList(false);
                                                    setShowUpdate(false);
                                                    setShowView(false);
                                                }}
                                                className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
                                                data-upgraded=",MaterialButton,MaterialRipple"
                                            >
                                                <i className="material-icons"> add_circle</i> New Site
                                                <span className="mdl-button__ripple-container">
                                                    <span className="mdl-ripple"></span>
                                                </span>
                                            </button>
                                        )}
                                    </header>
                                    <div className="tools">
                                        <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                                    </div>
                                </div>

                                {rloading && <Loading loading={rloading} />}

                                {!rloading && (
                                    <div className="card-body height-9">
                                        <SiteList
                                            sites={rdata && rdata.GetSiteParent.doc.sites}
                                            onUpdate={(s) => {
                                                setSite(s);
                                                setShowUpdate(true);
                                                setShowSiteList(false);
                                                setShowView(false);
                                            }}
                                            onView={(s) => {
                                                setSite(s);
                                                setShowUpdate(false);
                                                setShowSiteList(false);
                                                setShowView(true);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}

                {/* Start of Create New Site Form */}
                {!site_item && !showSiteList && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>New Site Form</header>
                            </div>
                            <div className="card-body">
                                <Loading loading={loading} />

                                <CreateSite
                                    onSubmit={async (item) => {
                                        await NewSite({
                                            variables: {
                                                model: item,
                                                id: ref,
                                            },
                                        });
                                        setShowSiteList(true);
                                        setShowUpdate(false);
                                        setShowView(false);
                                    }}
                                    siteTypes={rdata && rdata.GetAllSiteType.docs}
                                    onCancel={() => {
                                        setShowSiteList(true);
                                        setShowUpdate(false);
                                        setShowView(false);
                                        setSite(null);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {/* End of Create New Site Form */}

                {/* Start of Update  Site Form */}
                {showUpdate && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 fade-in">
                        <Loading loading={uLoading} />
                        <SiteUpdate
                            onSubmit={async (updatedItem) => {
                                const { name, email, tel, type, logo, website, address } = updatedItem;
                                await UpdateSite({
                                    variables: {
                                        id: site_item.id,
                                        update: {
                                            name,
                                            email,
                                            tel,
                                            type,
                                            logo,
                                            website,
                                            address,
                                        },
                                    },
                                });
                                setShowUpdate(false);
                                setShowSiteList(true);
                                setShowView(false);
                            }}
                            onCancel={() => {
                                setShowSiteList(true);
                                setShowUpdate(false);
                                setShowView(false);
                                setSite(null);
                            }}
                            currentItem={site_item}
                            types={rdata.GetAllSiteType.docs}
                        />
                    </div>
                )}
                {/* End of Update Site Form */}

                {/* Start of View Site */}
                {showView && (
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 fade-in">
                        <ViewSite
                            currentItem={site_item}
                            types={rdata.GetAllSiteType.docs}
                            onBack={() => {
                                setShowSiteList(true);
                                setShowUpdate(false);
                                setShowView(false);
                                setSite(null);
                            }}
                        />
                    </div>
                )}
                {/* End of View Site */}
            </div>
        </>
    );
};

export default Site;
